module.exports = __webpack_public_path__ + "static/scale-model-of-rivers-park-in-springfield-massachusetts-481127dd7245977c9214cc34916ce6c2.png";